export class DunningBlockFilter {
    public IncludeInactive?: boolean;
}

export default DunningBlockFilter;